import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mayoristas-comunicados',
  templateUrl: './mayoristas-comunicados.component.html',
  styleUrls: ['./mayoristas-comunicados.component.css']
})
export class MayoristasComunicadosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
